<script>
  import service from '../../../../domain/leiloes/services'

  export default {
    name: 'tipo-bem-campos',
    props: {
      value: {
        required: true
      }
    },
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        campos: null
      }
    },
    computed: {
      model: {
        get () {
          return this.value === null ? null : this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      filteredData () {
        if (!this.model && !this.campos) {
          return null
        }
        if (this.model && this.campos) {
          this.model.forEach((m) => {
            this.campos.forEach((c) => {
              if (c.id !== m.tipo) {
                this.model.push({nome: c.nome, tipo: c.id, valor: null})
              } else {
                m.nome = c.nome
              }
            })
          })
        }
        if (this.campos && !this.model) {
          return this.campos
        }
        return this.model
      }
    },
    mounted () {
    },
    destroyed () {
    },
    methods: {
      load (id) {
        this.isLoading = true
        service.buscaCamposTiposBem(id).then((response) => {
          this.isLoading = false
          this.isLoaded = true
          this.campos = response.data.campos
          // this.model = this.filteredData
        })
          .catch((response) => {
            this.isLoading = false
            window.responseError(response)
            console.log(response)
          })
      }
      /* atualizaCampos () {
        let result = []
        let v = this.campos
        if (v.length > 0) {
          for (let i = 0; i < v.length; i++) {
            result.push({tipo: v[i]['id'], valor: v[i]['valor']})
          }
        } else {
          result = null
        }
        this.$emit('updateTipoBemCampos', result)
      } */
    },
    components: {}
  }
</script>

<template>
  <div v-if="isLoaded">
    <div class="form-group" v-for="campo in model">
      <label class="col-lg-2 control-label">{{ campo.nome }}</label>
      <div class="col-lg-10">
        <input type="text" class="form-control w-auto" v-model="campo.valor"
               :required="campo.obrigatorio"/>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// TipoBemCampos.vue?44d63a04